/**
 * SparkleIcon · 4 瓣拉长星形（与设计稿一致）
 *
 * 基于 Lucide 「sparkle」路径（业界设计验证）：
 *  · 4 瓣顶点距中心 ~9.8，几乎贴 24×24 viewBox 边缘，填充率高；
 *  · 每个顶点用半径 0.5 的小弧线封口，视觉上是微圆角而非锐角；
 *  · 4 个瓣根（valley）用半径 2 的凹弧连接，凹陷柔和过渡而非折线。
 *
 * 复用场景：
 *  · EmptyState（建夹页欢迎区） hero
 *  · ChatFeed empty（AI 助手侧栏空会话） hero
 *
 * 颜色随 currentColor，外层用 color 控制。
 */

import React from 'react'

export interface SparkleIconProps {
  /** 渲染尺寸（width=height），默认 22 */
  size?: number
  className?: string
}

const SparkleIcon: React.FC<SparkleIconProps> = ({ size = 22, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.582a.5.5 0 0 1 0 .962L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.962 0z"
      fill="currentColor"
    />
  </svg>
)

export default SparkleIcon
